import { stringify } from "querystring";
import { RECENT_ORDERS } from "../constants/action-types";
import { Map } from "immutable";
import { extractIdFromValue } from "components/filters/auto-complete";

export function fetchRecentOrders(params, next) {
    return (dispatch, getState) => {
        const { nextPage } = getState().recentOrders;
        if (next && !nextPage) {
            return;
        }
        let url = nextPage;
        if (!next || !url) {
            const { filters = Map<string, any>(), search, sort = "modified_on", sortOrder = "desc" } = params;

            const filtersObj = filters.toJS();

            // Extract IDs from __to_id__ values
            Object.keys(filtersObj).forEach((key) => {
                filtersObj[key] = extractIdFromValue(filtersObj[key]);
            });

            const query = {
                __search: search,
                __limit: 25,
                __sort: `__${sort}`,
                __sort_order: sortOrder,
                __fields:
                    "_id,__modified_on,__ship_start,__order_number,__total,__status,__status_name,__brand,__brand_name,__customer_po_number,__currency_code",
                __status: ["draft", "review", "pending", "approved", "processed", "shipped", "cancelled"], // statuses supported by default
                __dashboard_call: true,
                ...filtersObj,
            };
            url = `/api/v3.0/orders?${stringify(query)}`;
        }
        if (!next) {
            dispatch({ type: RECENT_ORDERS.UPDATE, payload: [] });
        }
        dispatch({
            type: RECENT_ORDERS.FETCH.START,
            payload: { url, next, removeActiveBrand: params.removeActiveBrand },
        });
    };
}
